export default __webpack_public_path__ + "static/media/MaskGroup14.1d7e0616.svg";